import React from "react";
import {
  Box,
  Grid,
  IconButton,
  Typography,
  Link as MUILink,
} from "@mui/material";
import { Link } from "react-router-dom";

import {
  resourcesRoutesCompany,
  resourcesRoutesLearn,
} from "@/utils/navigation";

import App_store_icon from "@/assets/icons/app-icons/app-store-badge.svg?react";
import Google_play_icon from "@/assets/icons/app-icons/google-play-badge.svg?react";
import resources_map_url from "@/assets/images/navbar/resources-map.jpg";
import resources_map_thumbnail_url from "@/assets/images/navbar/resources-map_thumbnail.jpg";
import AnimatedImage from "@/components/UI-Kit/AnimatedImage";

interface IProps {
  closeDropDown: () => void;
}

const ResourcesMenu: React.FC<IProps> = ({ closeDropDown }) => {
  const resourcesRoutes = [
    { title: "Company", data: resourcesRoutesCompany },
    { title: "Learn", data: resourcesRoutesLearn },
  ];

  return (
    <Grid container spacing={2}>
      {resourcesRoutes.map(({ title, data }, index) => (
        <Grid key={index} item xs={12} lg={3.75} xl={4}>
          <Typography variant="h4" mb={{ xs: 1, lg: 2.25 }} component="h4">
            {title}
          </Typography>
          <Box
            component="ul"
            display="flex"
            flexDirection="column"
            gap={{ xs: 0, lg: 1.5 }}
            pl={{ xs: 3, lg: 0 }}
            m={0}
          >
            {data.map(({ path, title }) => (
              <Box component="li" key={path} sx={{ listStyle: "none" }}>
                <MUILink
                  component={Link}
                  to={path}
                  py={{ xs: 1, lg: 1.5 }}
                  display="block"
                  width="100%"
                  style={{ textDecoration: "none" }}
                  onClick={closeDropDown}
                >
                  <Typography
                    variant="subtitle1"
                    component="p"
                    fontWeight={700}
                    color="inherit"
                    textTransform="capitalize"
                  >
                    {title}
                  </Typography>
                </MUILink>
              </Box>
            ))}
          </Box>
        </Grid>
      ))}

      <Grid
        item
        xs={12}
        lg={4.5}
        xl={4}
        sx={{
          display: { xs: "block", lg: "flex" },
          justifyContent: "end",
        }}
      >
        <Box maxWidth={420}>
          <Typography
            variant="subtitle1"
            component="h4"
            pt={{ xs: 0, lg: 4 }}
            mb={{ xs: 2, lg: 3 }}
            fontWeight={700}
          >
            Get the App
          </Typography>
          <AnimatedImage
            sx={{
              mb: { xs: 2, lg: 4 },
              img: {
                width: { xs: "100%", lg: 420 },
                height: "auto",
              },
            }}
            thumbnailUrl={resources_map_thumbnail_url}
            mainUrl={resources_map_url}
            alt="resources map"
          />
          <Box
            display="flex"
            gap={{ xs: 2, sm: 3, lg: 3 }}
            pb={{ xs: 3, lg: 4 }}
          >
            <a
              href="https://apps.apple.com/us/app/trackmategps/id1109000685?platform=iphone"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconButton sx={{ padding: 0 }}>
                <App_store_icon />
              </IconButton>
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.fleetManagementServices.pinspot&hl=en&gl=US"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconButton sx={{ padding: 0 }}>
                <Google_play_icon />
              </IconButton>
            </a>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ResourcesMenu;
